import './VolunteerHero.css'
import volunteerHeroSVG from '../../media/svg/Honk_People_Web_small_header.svg'
import Button from '../Button'

export default function VolunteerHero() {
  return (
    <div className="volunteer-hero-container">
      <div className="bg-community">
        <img alt="" className="bg-community" src={volunteerHeroSVG} />
        <h1>Volunteer</h1>
      </div>

      <div className="location-table-container">
        <h3>
          For volunteer opportunities please sign up here:
        </h3>
          <a href="https://www.signupgenius.com/go/10C0549AFAE23AAFBC43-57319667-honkpdx#/" 
              target="_blank"
              rel="noreferrer"
            >
              <Button background="brass" text="VOLUNTEER!" />
            </a>
      </div>
    </div>
  )
}